<template>
    <div class="refund">
        <section class="home-cards">
        <h4>Refund Policy</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/logo.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>REFUND OF SCHOOL FEES AND OTHER PAYMENT</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>When a pupil registers in a school, it is understood that he / she enrolling for the entire school year for pre- elementary and elementary subjects.</li>
                  <li>A pupil who transfers or otherwise withdraws in writing, within one week after the beginning of classes and has already paid the pertinent fees and other school fees in full or any length of time will be charged according to the policies on the refund school fees and other fees</li>
                </ol>
                </div>
                <div class="feature-title">
                <h5>REFUND POLICES</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>Registration fee, school requirement, building and maintenance, computer and PTA fees are non-refundable.</li>
                  <li>50% Refund: Withdraw 7 days prior to the day of the first term. No refund will be accepted after 1 month of reporting.</li>
                  <li>30% Refund: Withdraw 7 days prior to the day of the first term. No refund will be accepted after 1 month of reporting.</li>
                  <li>20% Refund: Withdraw 7 days prior to the day of the first term. No refund will be accepted after 1 month of reporting. No Refunds or credit will be given after that time. Request for refund must be submitted in writing and dated postmark determine edibility for refund. Written refund can be submitted to Accounts Office</li>
                </ol>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'Refund',
  components: { }
}
</script>

<style>
.refund .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.refund .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.refund .home-cards .home-cards-main {
  padding: 1em;
  max-width: 800px;
  margin: 0 auto;
  background-color: var(--inspire-gold);
}
.refund .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.refund .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.refund .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.refund .feature p {
  color: var(--inspire-charcoal);
}
.refund .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.refund .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.refund .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
